import { render } from "./Gallery2.vue?vue&type=template&id=00723312&scoped=true"
import script from "./Gallery2.vue?vue&type=script&lang=js"
export * from "./Gallery2.vue?vue&type=script&lang=js"

import "./Gallery2.vue?vue&type=style&index=0&id=00723312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00723312"]])

export default __exports__